import { useTranslation } from 'react-i18next'

import { ConfirmationModal } from '../../../Confirmation'
import {
  getListingPortalLabel,
  getMockPortalLiveAdCount,
} from '../../../RentalPortalListing'
import { QA_NAME_INTEGRATIONS_DISCONNECT } from '../RentalPortalIntegrations.constants'

import { getIntegrationsDisconnectDescription } from './IntegrationsDisconnectModal.utils'

// TODO: take the live ad count from the integrations status once it serves it.
function IntegrationsDisconnectModal({ isSaving, portal, onCancel, onSubmit }) {
  const { t } = useTranslation()

  return (
    <ConfirmationModal
      actionButtonsProps={{
        submitText: t('RentalPortal.IntegrationsDisconnectBtnKey'),
      }}
      description={getIntegrationsDisconnectDescription({
        liveAdCount: getMockPortalLiveAdCount(portal),
        portal: getListingPortalLabel(portal),
        t,
      })}
      loading={isSaving}
      qaName={QA_NAME_INTEGRATIONS_DISCONNECT}
      title={t('RentalPortal.IntegrationsDisconnectTitleKey', {
        portal: getListingPortalLabel(portal),
      })}
      onCancel={onCancel}
      onSubmit={onSubmit}
    />
  )
}

export default IntegrationsDisconnectModal
